export class BaseState {
	public message = '';
	public hasError = false;
	public isLoading = false;
	public hasSuccess = false;


	public setLoading = (isLoading: boolean) => {
		this.isLoading = isLoading;
	};

	
	public setError = ( message : string ) => {
	    this.clearSuccess();
		this.hasError = true;
	    this.setMessage(message);
	};
	
	public clearError = () => {
	    this.clearMessage();
	    this.hasError = false;
	}	
	
	public setSuccess = ( message : string ) => {
		this.clearError();
		this.hasSuccess = true;
	    this.setMessage(message)
	};
	
	public clearSuccess = () => {
	    this.clearMessage();
	    this.hasSuccess = false;
	}
	
	public clearSuccessAndError = () => {
	    this.clearError();
	    this.clearSuccess();
	}
	
	private setMessage = ( message : string ) => {
	    this.message = message;
	}
	
	private clearMessage = () => {
	    this.message = null;
	}
}